/* ═══════════════════════════════════════
   Päiväyksen esitysmuoto — YKSI PAIKKA.

   Toni 21.9.2026: käyttäjä lukee `21.9.2026`, ei `2026-09-21`.

   ⛔ RAJA: tämä on ESITYS, ei arvo. Kanta, rajapinta ja tiedostoviennit
   pysyvät ISO-muodossa — siellä muoto on lajiteltava ja koneluettava, ja
   `p.k.vvvv` rikkoisi molemmat. Muunnos tapahtuu vasta ruudulla.

   ⚠ `new Date("2026-09-21")` tulkitaan UTC-keskiyöksi ja siirtyy
   paikallisaikaan — Suomessa se on sama päivä, mutta negatiivisella
   siirtymällä edellinen. Päivä on kalenteriarvo eikä hetki, joten se
   pilkotaan merkkijonona eikä ajaksi. Sama vika kuin Excelin
   sarjanumeroissa: oikea luku väärässä yksikössä.
   ═══════════════════════════════════════ */

import { lokaali, t } from "./kieli";

/* T439 (7.10.2026): muoto p.k.vvvv pysyy kaikilla kielillä — päivä ensin ja pisteet, yksiselitteinen myös Norjassa.
   Kielen mukaan vaihtuvat vain sana «klo» ja kellonajan lokaali. */

/** ISO-päivä (`2026-09-21`) tai aikaleima → `21.9.2026`. Tyhjä → `null`. */
export function naytaPvm(arvo: string | null | undefined): string | null {
  if (!arvo) return null;
  const osuma = /^(\d{4})-(\d{2})-(\d{2})/.exec(arvo);
  if (!osuma) return arvo;            // tuntematon muoto näytetään sellaisenaan
  const [, v, k, p] = osuma;
  return `${Number(p)}.${Number(k)}.${v}`;
}

/** Sama, mutta tyhjä on viiva — listassa tyhjä solu ja puuttuva päivä
 *  näyttäisivät muuten samalta. */
export const pvmTaiViiva = (arvo: string | null | undefined): string =>
  naytaPvm(arvo) ?? "—";

/** Aikaleima → `21.9.2026 klo 02:48`. Kellonaika on hetki, joten se
 *  luetaan paikallisajassa — toisin kuin pelkkä päivä. */
export function naytaPvmKello(arvo: string | null | undefined): string | null {
  if (!arvo) return null;
  const d = new Date(arvo);
  if (Number.isNaN(d.getTime())) return arvo;
  const kello = d.toLocaleTimeString(lokaali(), { hour: "2-digit", minute: "2-digit" });
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${t("aika.klo")} ${kello}`;
}
